export default "__VITE_ASSET__BVY8kNHL__"